import clsx from "clsx";
import { DiceIcon } from "@/shared/icons";

type Props = {
  className?: string;
  onClick: () => void;
};

export default function CreateCharacterRandomAll({ className, onClick }: Props) {
  return (
    <button
      type="button"
      className={clsx(
        "bg-matched/85 hover:bg-matched/95 active:bg-matched text-white/85 transition uppercase text-xxs flex overflow-hidden font-bold h-12 items-center rounded-2xl absolute right-[38.5rem] top-[--boundary-offset-x] p-1",
        className,
      )}
      onClick={onClick}
    >
      <div className="px-3">Случайно</div>
      <div className="btn btn-icon variant-solid-gradient h-10">
        <DiceIcon size={20} className="-scale-x-100" />
      </div>
    </button>
  );
}
